import './DeepDiveSlide.css';
import React, { useEffect, useState } from 'react';
import { Box, Grid, List, ListItem, Typography } from '@mui/material';
import { fetchDiveElements } from '../../../backend/dive_elements';
import { DiveElement } from '../../../../data_types';

const DeepDiveSlide = () => {
    const [error, setError] = useState<string | null>(null);
    const [headline, setHeadline] = useState<string>("");
    const [diveElements, setDiveElements] = useState<DiveElement[]>([]);

    useEffect(() => {
        const loadDiveElements = async () => {
            try {
                const data = await fetchDiveElements();

                if (data) {
                    setHeadline(data.headline || ""); // Store headline separately
                    setDiveElements(data.elements || []); // Store elements separately
                } else {
                    setError('No dive element data available');
                }
            } catch (error) {
                setError('Failed to fetch dive elements');
                console.error(error);
            }
        };
        loadDiveElements();
    }, []);

    return (
        <Box className='slide' id='deep_dive_slide'>
            <Grid className='slide_container' id='deep_dive_slide_container' justifyContent={'center'}>
                <Box 
                    className="headline"
                    sx={{
                        fontSize: { xs: '32px', sm: '48px', md: '60px' }, // Responsive font size for headline
                        color: 'var(--color-palette-3)', // Custom color
                        fontWeight: 'bold', // Optional for emphasis
                    }}
                >
                    {headline}
                </Box>
                <Box className="list-container" id="deep-dive-list-container">
                    {diveElements.length > 0 ? (
                        <List>
                            {diveElements.map((diveElement, index) => (
                                <ListItem key={index} className="dive-item">
                                    {index !== 0 && <div className="dive-item-separator"></div>}
                                    <Box className="dive-item-text-container">
                                        <Box 
                                            className="dive-item-title"
                                            sx={{
                                                fontSize: { xs: '26px', sm: '38px', md: '47px' }, // Responsive font size for title
                                                color: 'var(--color-palette-3)', // Custom color
                                                fontWeight: 'bold', // Optional for emphasis
                                            }}
                                        >
                                            {diveElement.title}
                                        </Box>
                                        <Box 
                                            className="dive-item-description"
                                            sx={{
                                                fontSize: { xs: '16px', sm: '22px', md: '30px' }, // Responsive font size for description
                                                color: 'white', // Ensuring text color is white
                                            }}
                                        >
                                            {diveElement.description}
                                        </Box>
                                    </Box>
                                </ListItem>
                            ))}
                        </List>
                    ) : (
                        <Typography>No dive elements available</Typography>
                    )}
                </Box>
            </Grid>
        </Box>
    );
};

export default DeepDiveSlide;
